﻿// Scales the desktop-composition hero to the screen width on phones and tablets (see itc-celestial.css).
(() => {
  const set = () => document.documentElement.style.setProperty('--itc-hero-zoom', String(Math.min(1, window.innerWidth / 980)));
  set();
  window.addEventListener('resize', set);
})();
